import { createContext, useContext, useEffect, useRef, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking, null = signed out
  const processed = useRef(false);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes("session_id=")) {
      // Returning from Google OAuth — exchange session_id FIRST, skip the /me check.
      if (processed.current) return;
      processed.current = true;
      const sessionId = hash.split("session_id=")[1].split("&")[0];
      fetch(`${API}/api/auth/session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ session_id: sessionId }),
      })
        .then((r) => (r.ok ? r.json() : null))
        .then((u) => {
          setUser(u);
          window.history.replaceState(null, "", window.location.pathname);
        })
        .catch(() => setUser(null));
      return;
    }
    fetch(`${API}/api/auth/me`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((u) => setUser(u))
      .catch(() => setUser(null));
  }, []);

  const logout = async () => {
    try {
      await fetch(`${API}/api/auth/logout`, { method: "POST", credentials: "include" });
    } finally {
      setUser(null);
    }
  };

  return <AuthContext.Provider value={{ user, logout }}>{children}</AuthContext.Provider>;
}
